import type { App } from "vue";
import { useUser } from "@domain/Security/User";
import Analytics, { type AnalyticsInstance } from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
import googleAnalytics from '@analytics/google-analytics';
import { TagManager } from "../Directives/TagManager";

/**
 * Internal static instance of the Analytics object
 */
class InternalAnalyticsInstance
{
    static instance: AnalyticsInstance;
}

/**
 * Sends a tag event to Google Analytics, annotated with metadata parameters to identify
 * the Carbucks App and Business details, and an optional set of additional parameters
 * @param tag 
 * @param parameters 
 */
export function trackEvent( tag: string, parameters?: object )
{

    const user = useUser();
    const metadata = {
        'appName': user?.appName,
        'businessName': user?.businessName,
        'businessId': user?.businessId
    };

    const params = { ...metadata, ...parameters ?? {} };
    InternalAnalyticsInstance.instance.track( tag, params );
    
}

/**
 * Gets the Google Analytics instance
 * @returns 
 */
export function useAnalytics()
{
    return InternalAnalyticsInstance.instance;
}

/**
 * Registers Google Analytics, Google Tag Manager and the associated directives
 * @returns 
 */
export function useGoogleAnalytics()
{
    return {

        install: async ( app: App<any> ) =>
        {

            // Configure analytics and tag manager
            InternalAnalyticsInstance.instance = Analytics( {
                app: 'carbucks',
                plugins: [
                    googleAnalytics( {
                        measurementIds: [ import.meta.env.VITE_GOOGLE_ANALYTICS_ID ],
                        gtagConfig: {
                            cookie_update: 'false',
                            cookie_flags: 'SameSite=None; Secure'
                        }
                    } ),
                    googleTagManager( {
                        containerId: import.meta.env.VITE_GOOGLE_TAGMANAGER_ID,
                        gtagConfig: {
                            cookie_update: 'false',
                            cookie_flags: 'SameSite=None; Secure'
                        }
                    } )
                ]
            } );
        
            // Register the google tag manager directive for buttons "v-tag"
            TagManager( app );

        }

    };
}
